/** 与 orderList/components/OrderDetail.vue 一致：os 有值时 == '1' 为安卓，否则为苹果；无值为 '-' */
export function formatOrderOs(val: unknown): string {
  if (!val) return '-'
  return val == '1' ? '安卓' : '苹果'
}
